import ShModel from 'sh-www/models/sh-model';
import { hasMany, attr } from '@ember-data/model';

/**
 * @typedef {number[]} VerifiedStatuses
 * An array of status values corresponding to the level of verification
 */

/** @type {number} No work samples supporting this service */
const STATUS_NOT_VERIFIED = 0;

/** @type {number} Has unverified or inaccessible work sample with this service */
const STATUS_UNSUPPORTED_VERIFIED = 1;

/** @type {number} Has verified, accessible work sample with this service */
const STATUS_VERIFIED = 2;

/** @type {VerifiedStatuses} */
const VERIFIED_STATUSES = [
  STATUS_NOT_VERIFIED,
  STATUS_UNSUPPORTED_VERIFIED,
  STATUS_VERIFIED,
];

export const SERVICE = {
  VERIFIED_STATUSES,
};

class Service extends ShModel {
  @attr('string') name;
  @attr('string') pluralizedName;
  @attr('string') category;
  @attr('number') status;

  @hasMany('user', { async: false }) user;
  @hasMany('service-synonym', { async: false }) serviceSynonyms;

  /**
   * Available when included from ServiceUser pivot
   */
  get verified() {
    return this.status === STATUS_VERIFIED;
  }
};

export default Service;
